import React from 'react'
import CardContent from '@mui/material/CardContent'
import {CenteredCard} from 'components'

const StatusPage = ({children}) => {
  return (
    <CenteredCard>
      <CardContent>
        {children}
      </CardContent>
    </CenteredCard>
  )
}

export default StatusPage